// extracted by mini-css-extract-plugin
module.exports = {"player":"Player_player__1W0rs","player__img":"Player_player__img__2_HvH","spin":"Player_spin__1biTD"};